import api from './api';
import { Schedule, PaginatedResponse } from '../types';

export interface ScheduleFilters { page?: number; limit?: number; search?: string; }

const schedulesService = {
  getList: async (filters: ScheduleFilters = {}): Promise<PaginatedResponse<Schedule>> => {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));
    if (filters.search) params.append('search', filters.search);
    const response = await api.get(`/schedules?${params.toString()}`);
    return response.data;
  },
  getById: async (id: number): Promise<Schedule> => (await api.get(`/schedules/${id}`)).data.data,
  create: async (data: Partial<Schedule> & { templeId?: number | null }): Promise<Schedule> => (await api.post('/schedules', data)).data.data,
  update: async (id: number, data: Partial<Schedule> & { templeId?: number | null }): Promise<Schedule> => (await api.put(`/schedules/${id}`, data)).data.data,
  delete: async (id: number): Promise<void> => { await api.delete(`/schedules/${id}`); },
};
export default schedulesService;
